import {BannerConstantJs} from 'OK/banners/bannerNew/utils/BannerConstantJs';
import {IBannerTransportJs} from "OK/banners/bannerNew/transport/IBannerTransportJs";
import {BannerTransportJs} from 'OK/banners/bannerNew/transport/BannerTransportJs';
import {IBannerData, BannerDataNull} from 'OK/banners/bannerNew/data/BannerDataNull';
import {BannerDataText} from 'OK/banners/bannerNew/data/BannerDataText';
import {BannerDataJson} from 'OK/banners/bannerNew/data/BannerDataJson';
import {CurrentUserCfg} from 'OK/CurrentUserCfg';
import {BannerDataImage, IBannerDataImageOptions} from "OK/banners/bannerNew/data/BannerDataImage";
import {ValueProviderJs} from "OK/banners/bannerNew/ValueProviderJs";
import {BannerParamsJs} from "OK/banners/bannerNew/config/BannerParamsJs";
import * as utils from 'OK/utils/utils';

export class BannerModelJs {
    slot: ValueProviderJs<number>;
    params: BannerParamsJs;
    loader: IBannerTransportJs;

    constructor(slot: ValueProviderJs<number>, params: BannerParamsJs, loader: IBannerTransportJs) {
        this.loader = loader;
        this.slot = slot;
        this.params = params;
    }

    request(container: HTMLElement, ready: IResponseListenerJs): RequestJs {
        const request = new RequestJs(container, ready, this.slot);
        this.process(request);
        return request;
    }

    click(clickUrl: string) {

        let params = {
            r: Date.now() + ""
        };

        const json = CurrentUserCfg.getInstance().getBannerParameters();

        const t = json?.[BannerConstantJs.TARGETING_PARAMETER];
        if (t) {
            BannerTransportJs.appendParam(params, BannerConstantJs.TARGETING_PARAMETER, t);
        }

        this.loader.sendClick(clickUrl, params);
    }

    process(request: RequestJs) {
        if (this.slot.getValue() !== null) {
            this.sendReq(request);
        } else {
            request.handleResponse(null);
        }
    }

    sendReq(request: RequestJs) {
        this.loader.sendRequest(this.slot.getValue(), this.params.asJSON(), request);
    }
}

export class RequestJs {
    container: HTMLElement;
    ready: IResponseListenerJs;
    slot: ValueProviderJs<number>;
    bannerPlace: string | null;
    response?: IBannerData;
    cancellationListener?: IRequestCancellationListenerJs;

    constructor(container: HTMLElement, ready: IResponseListenerJs, slot: ValueProviderJs<number>) {
        this.container = container;
        this.ready = ready;
        this.slot = slot;
        this.bannerPlace = container ? container.getAttribute('data-place') : null;
    }

    getResponse(): IBannerData {
        return this.response!;
    }

    cancel() {
        this.cancellationListener?.onCancel?.();
    }

    handleResponse(response: string | null) {
        if (!response) { // Если пустой ответ, то баннера нет
            this.response = BannerDataNull.NULL;
        } else {
            const json = this.tryParseJSON(response);
            if (json === null) {
                this.response = new BannerDataText(response);
            } else {
                if (json.hasOwnProperty(BannerDataJson.INTERNAL_IMG_URL_KEY)) {
                    this.response = new BannerDataImage(json as IBannerDataImageOptions);
                } else {
                    this.response = BannerDataNull.NULL;
                }
            }
        }
        this.handleBannerDataResponse(this.response);
    }

    handleBannerDataResponse(bannerData: IBannerData) {
        this.ready.handleResponse(bannerData);
    }

    tryParseJSON(ser: string): object|null {
        ser = ser.trim();
        try {
            return utils.parseJson(ser);
        } catch (e) {
            return null;
        }
    }

    setCancellationListener(cancellationListener: IRequestCancellationListenerJs) {
        this.cancellationListener = cancellationListener;
    }
}

export interface IResponseListenerJs {
    handleResponse: Function;
}

interface IRequestCancellationListenerJs {
    onCancel?: Function;
}
